module.exports = __webpack_public_path__ + "img/10.0c9af416.png";